import { services } from "../../services";

// Define interfaces for type safety
interface ContractAddresses {
  token: string;
  nftContractAddress: string;
  escrowContractAddres: string; // Note: typo preserved from original code
  identityVerification: string;
  resellContract: string;
  propertyAssetImplementation: string;
  propertyFactory: string;
  tokenRegistry: string;
  rentalPool: string;
  ComplianceRegistry: string;
}

// Using a type-safe approach for networkId
let networkId: string | number = 1;

async function fetchNetworkId(): Promise<void> {
  networkId = await services.getNetworkId();
}

// Call the async function to fetch network ID
fetchNetworkId();

function getContractAddresses(): ContractAddresses {
  // For testing/development purposes (should be removed in production)
  // networkId = 4;

  // Using type coercion for safe comparisons
  const numericNetworkId =
    typeof networkId === "string" ? parseInt(networkId, 16) : networkId;

  if (networkId === "0x4" || numericNetworkId === 4) {
    return {
      token: "0x341218Eb704b45e72FFB73724E33a91F66f799dF", // USDT TOKEN
      nftContractAddress: "0xFaFFE2649Ef1092584fe01b92412E677A2DC3c1a",
      escrowContractAddres: "0x9Ff64Bb22FeF673251380D3e6A9eDD9634d63E71",
      identityVerification: "0x43570f1e8315E5C5d7a90A129a5044180c338A4D",
      resellContract: "0x8F99e3825b2dc1A337D2208058e8a9F8717308fa",
      propertyAssetImplementation: "0x9EC5E94758355944F4f414A33fF7385cD726B7C5",
      propertyFactory: "0xDA24c738F5ef3f34bD4E68Cb927C8423097bFeB6",
      tokenRegistry: "0xbDACC3d59E84A7abf59F0531Ee2ECeA702B7a095",
      rentalPool: "0x39B4e866d960adF903A203aC07a652335af2B900",
      ComplianceRegistry: "0x07115f5e97e3218328587Bb8bd6dFf452DCAAE8E",
    };
  } else if (numericNetworkId === 1 || networkId === "0x1") {
    return {
      token: "0x341218Eb704b45e72FFB73724E33a91F66f799dF", // USDT TOKEN
      nftContractAddress: "0xFaFFE2649Ef1092584fe01b92412E677A2DC3c1a",
      escrowContractAddres: "0x9Ff64Bb22FeF673251380D3e6A9eDD9634d63E71",
      identityVerification: "0x43570f1e8315E5C5d7a90A129a5044180c338A4D",
      resellContract: "0x8F99e3825b2dc1A337D2208058e8a9F8717308fa",
      propertyAssetImplementation: "0x9EC5E94758355944F4f414A33fF7385cD726B7C5",
      propertyFactory: "0xDA24c738F5ef3f34bD4E68Cb927C8423097bFeB6",
      tokenRegistry: "0xbDACC3d59E84A7abf59F0531Ee2ECeA702B7a095",
      rentalPool: "0x39B4e866d960adF903A203aC07a652335af2B900",
      ComplianceRegistry: "0x07115f5e97e3218328587Bb8bd6dFf452DCAAE8E",
    };
  } else {
    // Default network contracts
    return {
      token: "0x341218Eb704b45e72FFB73724E33a91F66f799dF", // USDT TOKEN
      nftContractAddress: "0xFaFFE2649Ef1092584fe01b92412E677A2DC3c1a",
      escrowContractAddres: "0x9Ff64Bb22FeF673251380D3e6A9eDD9634d63E71",
      identityVerification: "0x43570f1e8315E5C5d7a90A129a5044180c338A4D",
      resellContract: "0x8F99e3825b2dc1A337D2208058e8a9F8717308fa",
      propertyAssetImplementation: "0x9EC5E94758355944F4f414A33fF7385cD726B7C5",
      propertyFactory: "0xDA24c738F5ef3f34bD4E68Cb927C8423097bFeB6",
      tokenRegistry: "0xbDACC3d59E84A7abf59F0531Ee2ECeA702B7a095",
      rentalPool: "0x39B4e866d960adF903A203aC07a652335af2B900",
      ComplianceRegistry: "0x07115f5e97e3218328587Bb8bd6dFf452DCAAE8E",
    };
  }
}

export default getContractAddresses;

// import { services } from '../../services';

// // Define interfaces for type safety
// interface ContractAddresses {
//   token: string;
//   nftContractAddress: string;
//   escrowContractAddres: string; // Note: typo preserved from original code
//   identityVerification: string;
//   resellContract: string;
//   propertyAssetImplementation: string;
//   propertyFactory: string;
//   tokenRegistry: string;
//   rentalPool: string;
//   ComplianceRegistry: string;
// }

// // Using a type-safe approach for networkId
// let networkId: string | number = 1;

// async function fetchNetworkId(): Promise<void> {
//   networkId = await services.getNetworkId();
// }

// // Call the async function to fetch network ID
// fetchNetworkId();

// function getContractAddresses(): ContractAddresses {
//   // For testing/development purposes (should be removed in production)
//   // networkId = 4;

//   // Using type coercion for safe comparisons
//   const numericNetworkId = typeof networkId === 'string' ? parseInt(networkId, 16) : networkId;

//   if (networkId === '0x4' || numericNetworkId === 4) {
//     return {
//       token: '0x341218Eb704b45e72FFB73724E33a91F66f799dF', // USDT TOKEN
//       nftContractAddress: '0xFaFFE2649Ef1092584fe01b92412E677A2DC3c1a',
//       escrowContractAddres: '0x9Ff64Bb22FeF673251380D3e6A9eDD9634d63E71',
//       identityVerification: '0x0ce6bA611Dde7cE728f486f10504b935E9034779',
//       resellContract: '0x4Fa35505eb7E2d9ef12C08dD5F8EB64C0322a010',
//       propertyAssetImplementation: '0x8830C0e159fb8623f647A6f699e227f8b6123116',
//       propertyFactory: '0x258df922b5a4A7516e71596E7783F4dAB3054f95',
//       tokenRegistry: '0xD6d187162f3A851236d062a60E861cB6f47FE5F3',
//       rentalPool: '0x627139393cF8FAa8Da3a5e5E863304a9c233358E',
//       ComplianceRegistry: '0x5d70003A894f5f1813007a99Ac8D5B595f26C5B6',
//     };
//   } else if (numericNetworkId === 1 || networkId === '0x1') {
//     return {
//       token: '0x341218Eb704b45e72FFB73724E33a91F66f799dF', // USDT TOKEN
//       nftContractAddress: '0xFaFFE2649Ef1092584fe01b92412E677A2DC3c1a',
//       escrowContractAddres: '0x9Ff64Bb22FeF673251380D3e6A9eDD9634d63E71',
//       identityVerification: '0x0ce6bA611Dde7cE728f486f10504b935E9034779',
//       resellContract: '0x4Fa35505eb7E2d9ef12C08dD5F8EB64C0322a010',
//       propertyAssetImplementation: '0x8830C0e159fb8623f647A6f699e227f8b6123116',
//       propertyFactory: '0x258df922b5a4A7516e71596E7783F4dAB3054f95',
//       tokenRegistry: '0xD6d187162f3A851236d062a60E861cB6f47FE5F3',
//       rentalPool: '0x627139393cF8FAa8Da3a5e5E863304a9c233358E',
//       ComplianceRegistry: '0x5d70003A894f5f1813007a99Ac8D5B595f26C5B6',
//     };
//   } else {
//     // Default network contracts
//     return {
//       token: '0x341218Eb704b45e72FFB73724E33a91F66f799dF', // USDT TOKEN
//       nftContractAddress: '0xFaFFE2649Ef1092584fe01b92412E677A2DC3c1a',
//       escrowContractAddres: '0x9Ff64Bb22FeF673251380D3e6A9eDD9634d63E71',
//       identityVerification: '0x0ce6bA611Dde7cE728f486f10504b935E9034779',
//       resellContract: '0x4Fa35505eb7E2d9ef12C08dD5F8EB64C0322a010',
//       propertyAssetImplementation: '0x8830C0e159fb8623f647A6f699e227f8b6123116',
//       propertyFactory: '0x258df922b5a4A7516e71596E7783F4dAB3054f95',
//       tokenRegistry: '0xD6d187162f3A851236d062a60E861cB6f47FE5F3',
//       rentalPool: '0x627139393cF8FAa8Da3a5e5E863304a9c233358E',
//       ComplianceRegistry: '0x5d70003A894f5f1813007a99Ac8D5B595f26C5B6',
//     };
//   }
// }

// export default getContractAddresses;
